import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom, Subject, takeUntil } from 'rxjs';
import { Response } from '../../../../_shared/models';
import { CreateWorkOrderRequest } from '../models/work-order.models';
import { environment } from '../../../../../environments/environment';
import { KpiStatsResponse } from '../../../../_shared/models/kpi-response.model';
import { AccountFilterRequest } from '../../../../_shared/models/account-filter.model';

@Injectable({
  providedIn: 'root'
})
export class WorkOrderService {
  private http: HttpClient = inject(HttpClient);

  async createWorkOrderAsync(request: CreateWorkOrderRequest, cancellation: Subject<void>): Promise<Response<number>> {
    return firstValueFrom(
      this.http.post<Response<number>>(`${environment.apiEndpoint}/workorder/create-workorder`, request).pipe(takeUntil(cancellation))
    );
  }

  async getTotalWorkOrdersStatsKpi(request: AccountFilterRequest, cancellation: Subject<void>): Promise<Response<KpiStatsResponse>> {
    return firstValueFrom(this.http.post<Response<KpiStatsResponse>>(`${environment.apiEndpoint}/workorder/total-work-orders-summary`, request).pipe(takeUntil(cancellation)));
  }

  async getOverDueOrdersStatsKpi(request: AccountFilterRequest, cancellation: Subject<void>): Promise<Response<KpiStatsResponse>> {
    return firstValueFrom(this.http.post<Response<KpiStatsResponse>>(`${environment.apiEndpoint}/workorder/overdue-work-orders-summary`, request).pipe(takeUntil(cancellation)));
  }

  async getInProgressOrdersStatsKpi(request: AccountFilterRequest, cancellation: Subject<void>): Promise<Response<KpiStatsResponse>> {
    return firstValueFrom(this.http.post<Response<KpiStatsResponse>>(`${environment.apiEndpoint}/workorder/in-progress-work-orders-summary`, request).pipe(takeUntil(cancellation)));
  }

  async getAvgResolutionTimeStatsKpi(request: AccountFilterRequest, cancellation: Subject<void>): Promise<Response<KpiStatsResponse>> {
    return firstValueFrom(this.http.post<Response<KpiStatsResponse>>(`${environment.apiEndpoint}/workorder/avg-resolution-summary`, request).pipe(takeUntil(cancellation)));
  }
}